const convertName = (name: string) => {
  return name.toLowerCase().replaceAll(/\s+/g, '-');
};

export const handleActiveProject: HandleActiveProject = (
  title,
  navigate,
  searchParameters,
) => {
  const projectTitle = convertName(title);
  navigate(`/dashboard/${projectTitle}?${searchParameters.toString()}`);
};

export const handleFilterTags: HandleFilterTags = (
  tags,
  setSearchParameters,
) => {
  if (tags.length > 0) {
    const filterTags = tags.map((tag) => convertName(tag)).join('_');
    setSearchParameters({ filter: filterTags });
  } else {
    setSearchParameters({});
  }
};

export const handleFeaturedTags: HandleFeaturedTags = (tagName, navigate) => {
  navigate(`/dashboard?filter=${convertName(tagName)}`);
};
